<template>
  <v-snackbar
    v-model="uiStore.snackbar.model"
    :color="uiStore.snackbar.color"
    :timeout="uiStore.snackbar.timeout"
    location="top right"
    multi-line
  >
    {{ uiStore.snackbar.text }}
    <template #actions>
      <v-btn
        icon="mdi-close"
        variant="text"
        @click="uiStore.snackbar.model = false"
      />
    </template>
  </v-snackbar>
</template>

<script setup lang="ts">
/**
 * GlobalSnackbar.vue
 *
 * A globally accessible snackbar component that displays messages
 * controlled by the UI store.
 *
 * @author Alexander Funke
 * @lastChange 2025-08-26
 */

// --- Imports ---
import { useUiStore } from '@/stores/ui.store';
const uiStore = useUiStore();

// ---------------------------------------------------------------------------------------------------------------------

</script>
